import React from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'

import PropTypes from 'prop-types'
import uniqueId from 'lodash/uniqueId'
import moment from 'moment'

import MaterialTimePicker from 'material-ui/TimePicker'

import { Loader, Checkbox } from '../../../UI'
import DatePicker from 'react-datepicker'

import UPDATE_LOCAL_TOUR from './../../../../graphql/ActivitySteps/UpdateLocalTourEventDates.graphql'
import { NotificationManager } from 'react-notifications'

import 'react-datepicker/dist/react-datepicker.css'

const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

class EventDates extends React.Component {
  static propTypes = {
    currentSteps: PropTypes.object,
    updateLocalTour: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      errors: {
        repeat: 'Days should be selected',
        time: 'This field is required'
      },
      items: []
    }
  }

  componentDidMount() {
    if (this.props.currentSteps && Array.isArray(this.props.currentSteps.tourDates) && this.props.currentSteps.tourDates.length) {
      this.setState((state, props) => ({
        items: this.props.currentSteps.tourDates.map(item => ({
          eventDate: moment(item.eventDate),
          endRepeat: moment(item.endRepeat),
          repeatDays: [...item.repeatDays],
          isPrivate: false,
          repeat: item.repeatDays ? !!item.repeatDays.length : false,
          endDateShown: !!item.endRepeat,
          startingHour: moment(item.eventDate),
          timeError: false,
          repeatError: false
        }))
      }))
    } else {
      this.setState(() => ({
        items: [
          {
            eventDate: '',
            repeat: false,
            endDateShown: false,
            repeatDays: [],
            isPrivate: false,
            startingHour: moment().startOf('day'),
            timeError: false,
            repeatError: false
          }
        ]
      }))
    }
  }

  handleSubmit() {
    this.setState(
      () => ({
        saving: true,
        error: ''
      }),
      async () => {
        const repeatErrors = []
        const timeErrors = []

        this.state.items.forEach(item => {
          if (item.repeat && !item.repeatDays.length) {
            item.repeatError = true

            repeatErrors.push(item)
          }

          if (!item.startingHour) {
            item.timeError = true

            timeErrors.push(item)
          }
        })

        if (!timeErrors.length && !repeatErrors.length) {
          const tourDates = this.state.items.map(item => {
            const date = item.eventDate.format('YYYY-MM-DD') + 'T' + item.startingHour.format('HH:mm:ssZ')

            return {
              eventDate: moment(date).toISOString(),
              endRepeat: item.endRepeat,
              repeatDays: item.repeatDays,
              isPrivate: false
            }
          })

          try {
            await this.props.updateLocalTour({
              variables: {
                id: this.props.currentSteps.id,
                tourDates
              }
            })

            this.props.updateSteps()

            this.setState(
              () => ({
                saving: false
              }),
              () => {
                NotificationManager.success('Event dates updated', 'Success', 5000)
                if (Array.isArray(this.props.data.allLocalTours) && this.props.data.allLocalTours[0]) {
                  this.props.history.push(`/activity-steps/${this.props.data.allLocalTours[0].id}/booking-notice`)
                } else {
                  this.props.history.push('/activity-steps/booking-notice')
                }
              }
            )
          } catch (err) {
            NotificationManager.error('Error while updating event dates', 'Error', 5000)
            console.warn(err)
          }
        }
      }
    )
  }

  handleChange(date, index) {
    const items = [...this.state.items]

    items[index].eventDate = date

    this.setState(() => ({ items }))
  }

  handleEndDateChange(date, index) {
    const items = [...this.state.items]

    items[index].endRepeat = date

    this.setState(() => ({ items }))
  }

  onTimeChange = (value, index) => {
    const items = [...this.state.items]

    items[index].startingHour = value
    items[index].timeError = false

    this.setState(() => ({ items }))
  }

  handleAddClick() {
    this.setState(() => ({
      items: [
        ...this.state.items,
        {
          id: uniqueId(),
          repeat: false,
          repeatDays: []
        }
      ]
    }))
  }

  handleRemoveClick(index) {
    let items = [...this.state.items]
    items.splice(index, 1)
    this.setState(() => ({ items }))
  }

  toggleRepeat(index) {
    const items = [...this.state.items]
    items[index].repeat = !items[index].repeat
    items[index].repeatError = false
    this.setState(() => ({ items }))
  }

  toggleEndDate(index) {
    const items = [...this.state.items]
    items[index].endDateShown = !items[index].endDateShown
    if (items[index].endDateShown === false) {
      items[index].endRepeat = null
    } else {
      items[index].endRepeat = null
    }
    this.setState(() => ({ items }))
  }

  toggleDay(day, index) {
    const items = [...this.state.items]

    if (items[index].repeatDays.includes(day)) {
      items[index].repeatDays.splice(items[index].repeatDays.indexOf(day), 1)
    } else {
      items[index].repeatDays.push(day)
    }

    items[index].repeatError = false

    this.setState(() => ({ items }))
  }

  render() {
    const { t } = this.props

    if (this.props.loading) {
      return <Loader showLoader={true} />
    }

    return (
      <div className="steps-screen__form step-form faded-container">
        <div className="steps-screen__form-title">{t('event_dates')}</div>
        <div className="steps-screen__form-input-area">
          <div className="form-section">
            {this.state.items.map((el, index) => (
              <div key={index} className="removable-item-row">
                <div>
                  <div style={{ fontSize: 20, marginBottom: 15 }}>
                    Set the time of your activity. Each activity must be at least 1 hour.
                  </div>
                  <div className="steps-screen__form-subtitle">Trip № {index + 1}</div>
                  <div>
                    <div className="repeat-section__data-row">
                      <div className="row">
                        <div className="col-md-5 col-sm-5 event-datepicker event-input">
                          <DatePicker
                            className="form-control"
                            minDate={moment()}
                            excludeDates={[moment().isBefore(moment().subtract(1, 'days'))]}
                            selected={el.eventDate}
                            onSelect={date => this.handleChange(date, index)}
                            placeholderText="-- / -- / ----"
                          />
                        </div>
                        <div className="col-md-3 col-sm-3">
                          <label className="form-section__label-standard small-label">{t('starting_hour')}</label>
                        </div>
                        <div className="col-md-4 col-sm-4">
                          <MaterialTimePicker
                            id="activityStartTime"
                            className="material-time-picker"
                            format="24hr"
                            value={el.startingHour && el.startingHour.toDate()}
                            onChange={(_, value) => {
                              this.onTimeChange(moment(value), index)
                            }}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-5 col-sm-5" />
                        <div className="col-md-3 col-sm-3" />
                        <div className="col-md-4 col-sm-4">
                          <small className={el.timeError ? 'text-danger' : 'hidden'}>{this.state.errors.time}</small>
                        </div>
                      </div>
                    </div>
                    <div className="repeat-section">
                      <div className={el.eventDate ? 'repeat-section__data-row' : 'hidden'}>
                        <div className="row">
                          <div className="col-md-3 col-sm-3 event-input">
                            <Checkbox
                              id={'regerg-' + index}
                              value={el.repeat}
                              checked={el.repeat}
                              handleChange={() => this.toggleRepeat(index)}
                            >
                              {t('repeat')}
                            </Checkbox>
                          </div>
                          <div className="col-md-9 col-sm-9">
                            <div className={el.repeat ? 'repeat-section__days' : 'hidden'}>
                              {days.map((day, dayIndex) => (
                                <div
                                  key={dayIndex}
                                  onClick={() => this.toggleDay(day, index, dayIndex)}
                                  className={
                                    el.repeatDays.includes(day) ? 'repeat-section__days__day day-selected' : 'repeat-section__days__day'
                                  }
                                >
                                  {day}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <small className={el.repeatError ? 'text-danger' : 'hidden'}>{this.state.errors.repeat}</small>
                          </div>
                        </div>
                      </div>
                      <div className={el.repeat ? 'row repeat-section__data-row' : 'hidden'}>
                        <div className="col-md-7 col-sm-7 event-input">
                          <Checkbox
                            id={`endDate${index}`}
                            value={el.endDateShown}
                            checked={el.endDateShown}
                            handleChange={() => {
                              this.toggleEndDate(index)
                            }}
                            labelClass="form-section__label-standard"
                          >
                            {t('endDate')}
                          </Checkbox>
                        </div>
                        <div className={el.endDateShown ? 'col-md-5 col-sm-5 event-input' : 'hidden'}>
                          <DatePicker
                            minDate={moment()}
                            excludeDates={[moment().isBefore(moment().subtract(1, 'days'))]}
                            selected={el.endRepeat}
                            onSelect={date => this.handleEndDateChange(date, index)}
                            className="form-control"
                            placeholderText="-- / -- / ----"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.items.length > 1 && (
                  <div
                    className="remove-item-link"
                    onClick={() => {
                      this.handleRemoveClick(index)
                    }}
                  >
                    <span className="icon-cancel" /> {t('main:remove')}
                  </div>
                )}
              </div>
            ))}
            {this.state.error && <small className="text-danger">{this.state.error}</small>}
          </div>
          <div
            className="add-item-link"
            onClick={() => {
              this.handleAddClick()
            }}
          >
            <span className="icon-plus" /> {t('add_event')}
          </div>
        </div>
        <button
          className="btn btn-lg btn-primary btn-danger steps-submit-btn"
          onClick={() => {
            this.handleSubmit()
          }}
        >
          {t('main:save_continue')}
        </button>
      </div>
    )
  }
}

const enhance = compose(
  translate('activity_steps'),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)

export default enhance(EventDates)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/TimesLocation/EventDates.jsx